import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Receipt, ShoppingBag } from 'lucide-react';
import InvoiceList from './components/InvoiceList';
import { CounterSaleModal } from './CounterSaleModal';

export default function InvoiceHub() {
    const navigate = useNavigate();
    const [counterSaleOpen, setCounterSaleOpen] = useState(false);
    // Bumping this remounts the list so a sale recorded here appears without a
    // page refresh.
    const [refreshKey, setRefreshKey] = useState(0);

    return (
        <div className="space-y-6">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 pb-6 border-b border-line">
                <div className="flex items-center gap-3">
                    <div className="p-3 bg-accent/10 rounded-xl">
                        <Receipt className="w-6 h-6 text-accent" />
                    </div>
                    <div>
                        <h1 className="text-3xl font-bold text-fg tracking-tight">
                            Invoices
                        </h1>
                        <p className="text-fg-2 mt-1">
                            Manage invoices, payments, and financial records
                        </p>
                    </div>
                </div>

                {/* Counter sale lives here rather than on the dashboard: it's the
                    screen you're on when you want to bill something that never
                    had a job. */}
                <button
                    onClick={() => setCounterSaleOpen(true)}
                    className="flex items-center justify-center gap-2 h-11 px-5 rounded-lg font-semibold fd-btn-primary transition-all active:scale-[0.98] self-start md:self-auto"
                >
                    <ShoppingBag className="w-4 h-4" />
                    New counter sale
                </button>
            </div>

            <InvoiceList key={refreshKey} />

            <CounterSaleModal
                isOpen={counterSaleOpen}
                onClose={() => setCounterSaleOpen(false)}
                onCreated={(jobId) => {
                    setCounterSaleOpen(false);
                    setRefreshKey((k) => k + 1);
                    // Straight to the job so the sale can be invoiced — the
                    // counter sale isn't finished until there's an invoice.
                    navigate(`/workshop?job_id=${jobId}`);
                }}
            />
        </div>
    );
}
